import React, { useState, useEffect, useCallback } from 'react';
import monitoringService from '../services/monitoringService';

const AuditLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadLogs = useCallback(async () => {
    setLoading(true);
    try {
      const result = await monitoringService.getAuditLog(100);
      if (result.success) setLogs(result.data);
    } catch (err) {
      console.error('Audit log error:', err);
    }
    setLoading(false);
  }, []);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  const getActionBadge = (action) => {
    const colors = {
      'USER_TIER_CHANGE': 'bg-purple-100 text-purple-700',
      'PM2_RESTART': 'bg-orange-100 text-orange-700',
      'API_KEY_CREATE': 'bg-green-100 text-green-700',
      'API_KEY_DELETE': 'bg-red-100 text-red-700',
      'DEPLOY_TRIGGER': 'bg-blue-100 text-blue-700',
      'USER_DELETE': 'bg-red-100 text-red-700',
      'ALERT_RESOLVE': 'bg-green-100 text-green-700'
    };
    const color = colors[action] || 'bg-gray-100 text-gray-600';
    return <span className={`inline-flex py-0.5 px-2 rounded text-xs font-mono font-medium ${color}`}>{action}</span>;
  };

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
        <div className="w-10 h-10 border-[3px] border-gray-200 border-t-blue-500 rounded-full animate-spin" />
        <p className="text-gray-600 text-sm">감사 로그 로딩 중...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 max-w-[1200px] mx-auto">
      <div className="flex justify-between items-center">
        <h1 className="text-[28px] font-bold text-gray-900 m-0">감사 로그</h1>
        <button onClick={loadLogs} className="text-sm text-blue-500 hover:text-blue-700 bg-blue-50 px-4 py-2 rounded-lg">새로고침</button>
      </div>

      {logs.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <p className="text-4xl mb-4">📋</p>
          <p className="text-lg">감사 로그가 없습니다</p>
        </div>
      ) : (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="text-left py-3 px-4 font-medium text-gray-600">시간</th>
                <th className="text-left py-3 px-4 font-medium text-gray-600">관리자</th>
                <th className="text-left py-3 px-4 font-medium text-gray-600">작업</th>
                <th className="text-left py-3 px-4 font-medium text-gray-600">대상</th>
                <th className="text-left py-3 px-4 font-medium text-gray-600">상세</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50">
                  <td className="py-3 px-4 text-gray-500 text-xs whitespace-nowrap">
                    {new Date(log.created_at).toLocaleString('ko-KR')}
                  </td>
                  <td className="py-3 px-4 text-gray-700">{log.user_email || '-'}</td>
                  <td className="py-3 px-4">{getActionBadge(log.action)}</td>
                  <td className="py-3 px-4 text-gray-600">
                    {log.target_type && <span className="text-xs text-gray-400 mr-1">{log.target_type}:</span>}
                    {log.target_id || '-'}
                  </td>
                  <td className="py-3 px-4 text-gray-500 text-xs max-w-[200px] truncate">{log.details || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditLog;
